import { BoxSpg, DividerSpg, GridContainer, LabeledDataItem, TextSection } from "@duosoftbg/nacid-components";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";
import { useTranslation } from "react-i18next";

const ARUniEntryRequestData = ({ data, actions = null }) => {
  const { t } = useTranslation();

  return (
    <BoxSpg>
      <TextSection label={"t.arUniEntryRequest.common.details"} withDivider>
        <GridContainer>
          <LabeledDataItem labelCode={"l.arUniEntryRequest.createdDate"} data={data.createdDate} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.submittedDate"} data={data.submittedDate} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.createdUser"} data={data.createdUser} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.requestStatus"} data={data.requestStatus?.name} />
          {data.acadrecUniId && (
            <LabeledDataItem
              sm={12}
              md={12}
              labelCode={"l.arUniEntryRequest.acadrecUniId"}
              data={
                <a
                  href={`${ProcessEnvironments.Module.FrontOffice.Registers}/academic-recognitions/view?id=${data.acadrecUniId}&type=UNIVERSITIES`}
                  target={"blank"}
                >
                  {t("l.click.here")}
                </a>
              }
            />
          )}
        </GridContainer>
      </TextSection>
      <TextSection label={"t.arUniEntryRequest.applicant.details"} withDivider>
        <GridContainer>
          <LabeledDataItem labelCode={"l.arUniEntryRequest.applicant"} data={data.applicant} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.applicantEan"} data={data.applicantEan} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.citizenship"} data={data.citizenship?.name} />
        </GridContainer>
      </TextSection>
      <TextSection label={"t.arUniEntryRequest.diplomaUni.details"} withDivider>
        <GridContainer>
          <LabeledDataItem labelCode={"l.arUniEntryRequest.university"} data={data.university} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.universityCountry"} data={data.universityCountry?.name} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.educationLevel"} data={data.educationLevel} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.diplomaSpeciality"} data={data.diplomaSpeciality} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.diplomaNumber"} data={data.diplomaNumber} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.diplomaDate"} data={data.diplomaDate} />
        </GridContainer>
      </TextSection>
      <TextSection label={"t.arUniEntryRequest.recognized.details"} withDivider>
        <GridContainer>
          <LabeledDataItem
            labelCode={"l.arUniEntryRequest.recognizingUniversity"}
            data={data.recognizingUniversity?.universityName}
          />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.recognitionStatus"} data={data.recognitionStatus?.name} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.protocolNumber"} data={data.protocolNumber} />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.protocolDate"} data={data.protocolDate} />
          <LabeledDataItem
            labelCode={"l.arUniEntryRequest.recognizedEducationLevelId"}
            data={data.recognizedEducationLevel?.name}
          />
          <LabeledDataItem labelCode={"l.arUniEntryRequest.recognizedSpeciality"} data={data.recognizedSpeciality} />
          <LabeledDataItem
            labelCode={"l.arUniEntryRequest.recognizedProfGroup"}
            data={data.recognizedProfGroup?.name}
          />
        </GridContainer>
      </TextSection>
      {data.relatedRecognitionId && (
        <TextSection label={"t.arUniEntryRequest.relatedRecognition.details"} withDivider>
          <LabeledDataItem
            sm={12}
            md={12}
            labelCode={"l.arUniEntryRequest.relatedRecognitionId"}
            data={
              <a
                href={`${ProcessEnvironments.Module.FrontOffice.Registers}/academic-recognitions/view?id=${data.relatedRecognitionId}&type=UNIVERSITIES`}
                target={"blank"}
              >
                {t("l.click.here")}
              </a>
            }
          />
        </TextSection>
      )}
      {data.notes && (
        <TextSection label={"t.arUniEntryRequest.notes"} withDivider>
          <GridContainer>
            <LabeledDataItem sm={12} md={12} labelCode={"l.arUniEntryRequest.notes"} data={data.notes} />
          </GridContainer>
        </TextSection>
      )}
      {actions && <DividerSpg mt={4} />}
      {actions}
    </BoxSpg>
  );
};
export default ARUniEntryRequestData;
